import React from 'react';
import { Container } from './styles';

interface ThumbTutorialProps {
  img: string;
  video: string;
  onClick: (video: string) => void;
}

const ThumbTutorial: React.FC<ThumbTutorialProps> = ({ img, video, onClick }) => {
  return (
    <Container onClick={() => onClick(video)}>
      <img src={img} alt="" className="thumb-tutorial" />
    </Container>
  );
};

export default ThumbTutorial;
